// Architecture services mock data

export const architecturalServices = [
  {
    id: 1,
    name: "Home Extensions",
    icon: "Home",
    description: "Transform your property with expertly designed extensions that seamlessly blend with your existing home.",
    types: ["Rear Extensions", "Side Return Extensions", "Wraparound Extensions", "Two-Storey Extensions"],
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80"
  },
  {
    id: 2,
    name: "Loft Conversions",
    icon: "TrendingUp",
    description: "Unlock the potential of your unused attic space with a bespoke loft conversion designed to your needs.",
    types: ["Dormer Loft Conversions", "Hip-to-Gable Conversions", "Mansard Conversions", "Velux Conversions"],
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80"
  },
  {
    id: 3,
    name: "Basement Conversions",
    icon: "ArrowDown",
    description: "Maximise your property's value by converting your basement into functional, luxurious living space.",
    types: ["Full Basement Conversions", "Partial Conversions", "Basement Extensions", "Waterproofing Solutions"],
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80"
  },
  {
    id: 4,
    name: "New Builds",
    icon: "Building2",
    description: "From concept to completion, we design contemporary new build homes tailored to modern living.",
    types: ["Residential New Builds", "Multi-Unit Developments", "Eco-Friendly Homes", "Luxury Properties"],
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80"
  },
  {
    id: 5,
    name: "Planning Permission",
    icon: "FileCheck",
    description: "Navigate the complexities of planning with our expert guidance and proven track record of approvals.",
    types: ["Planning Applications", "Planning Appeals", "Permitted Development", "Feasibility Studies"],
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=800&q=80"
  },
  {
    id: 6,
    name: "Interior Design",
    icon: "Palette",
    description: "Complete your project with our interior design services that bring your architectural vision to life.",
    types: ["Space Planning", "Material Selection", "Lighting Design", "Kitchen & Bathroom Design"],
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=800&q=80"
  }
];

export const architectureProjects = [
  {
    id: 1,
    title: "Contemporary Glass Extension",
    location: "Kensington, London",
    type: "Rear Extension",
    year: 2024,
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80",
    description: "Sleek frameless glass extension with bi-fold doors opening to garden"
  },
  {
    id: 2,
    title: "Scandinavian Loft Suite",
    location: "Camden, London",
    type: "Loft Conversion",
    year: 2024,
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80",
    description: "Minimalist dormer conversion with skylight tunnels and oak finishes"
  },
  {
    id: 3,
    title: "Victorian Kitchen Extension",
    location: "Fulham, London",
    type: "Side Return",
    year: 2023,
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&q=80",
    description: "Period property enhanced with modern side-return and skylights"
  },
  {
    id: 4,
    title: "Underground Entertainment Space",
    location: "Notting Hill, London",
    type: "Basement Conversion",
    year: 2024,
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80",
    description: "Multi-functional basement with home gym and media room"
  },
  {
    id: 5,
    title: "Eco-Conscious Family Home",
    location: "Greenwich, London",
    type: "New Build",
    year: 2023,
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80",
    description: "Sustainable 5-bedroom residence with solar panels and rainwater harvesting"
  },
  {
    id: 6,
    title: "Industrial Loft Transformation",
    location: "Shoreditch, London",
    type: "Wraparound",
    year: 2024,
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&q=80",
    description: "Converted warehouse with exposed brick and steel-frame extension"
  },
  {
    id: 7,
    title: "Edwardian Garden Room",
    location: "Dulwich, London",
    type: "Rear Extension",
    year: 2023,
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80",
    description: "Traditional orangery-style extension with crittall doors"
  },
  {
    id: 8,
    title: "Minimalist White Box",
    location: "Highgate, London",
    type: "New Build",
    year: 2024,
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=80",
    description: "Contemporary architectural statement with floating staircase"
  },
  {
    id: 9,
    title: "Georgian Basement Refurbishment",
    location: "Belgravia, London",
    type: "Basement Conversion",
    year: 2023,
    image: "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?w=800&q=80",
    description: "Luxury wine cellar and private study beneath period townhouse"
  }
];

export const architectureProcess = [
  {
    step: 1,
    title: "Initial Consultation",
    description: "Free 30-minute consultation to discuss your project vision, budget, and timeline"
  },
  {
    step: 2,
    title: "Site Survey",
    description: "Comprehensive measured survey and feasibility assessment of your property"
  },
  {
    step: 3,
    title: "Design Development",
    description: "Detailed designs, 3D visualisations, and material specifications tailored to you"
  },
  {
    step: 4,
    title: "Planning Application",
    description: "Full planning application submission with our 95% approval success rate"
  },
  {
    step: 5,
    title: "Building Regulations",
    description: "Technical drawings and building control approval for construction"
  },
  {
    step: 6,
    title: "Construction Support",
    description: "Site visits and contractor liaison throughout the build process"
  }
];

export const architectureStats = [
  {
    value: "500+",
    label: "Projects Completed"
  },
  {
    value: "95%",
    label: "Planning Success Rate"
  },
  {
    value: "15+",
    label: "Years Experience"
  },
  {
    value: "4.8/5",
    label: "Client Satisfaction"
  }
];
